import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';

import Vas from '../../../Vas';
import '../../../css/CustomerPaymentData.css';

import CustomerPaymentDetails from './CustomerPaymentDetails';
import { DateTimeHelper } from 'utils-lib';
import { PagingTable,Icon,MessageBox } from 'component-lib';
import { RequestAjaxClass, PaymentsModel, PaymentOptionsModel } from 'models-lib';

var moment = require('moment');
        moment().format();
class CustomerPaymentData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Payments = [];
        this.state.CurrentView = "CustomerPaymentData";
        this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'):localStorage.getItem("vas_customerId");
        this.state.Ref=this.props.me;
        this.state.Limit = 10;
        this.state.Start = 0;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.PaymentsModel = new PaymentsModel([this],null,this.Request);
        this.state.PaymentId = "000000";
        this.EditPayment = true;
        this.PaymentConfig = Vas.Config.Payments;
        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.PaymentOptionsModel = new PaymentOptionsModel([this], null, this.Request2);
    }

    componentDidMount(){

      this.Request2.setApiUrl(Vas.ApiUrl);
      this.Request2.setApiKey(Vas.ApiKey);
      this.Request2.setAuth(true);

       //Ermittle das Datum für die Änderung der Zahlweise anhand des heutigen Datums
       var currentDate = moment();
       this.PaymentOptionsModel.CheckUpdateDate(moment([currentDate.year(), currentDate.month(), currentDate.date()]).format("YYYY-MM-DD"));

       this.LogoClick();

       this.FontSizeClick();
    }

    componentWillMount(){
      this.Request.setApiUrl(Vas.ApiUrl);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setAuth(true);
      this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
      });
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
          if(observer === "Payment"){
              let payments = [];
              if(this.PaymentsModel.Count > 0){
                  this.PaymentsModel.Payments.forEach(function(value) {
                      if (value.PaymentMethodValue === 4){
                          let payment = {};
                          payment.Id = value.Id;
                          payment.BankName = value.BankName;
                          payment.AccountOwner = value.AccountOwner;
                          payment.Iban= value.Iban.substr(value.Iban.length -6,6);
                          payment.BIC = value.Bic;
                          let from = "";
                          let to = "";
                          if (value.ValidFrom !== null && value.ValidFrom !== "")
                              {from = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.ValidFrom,true,localStorage.getItem('vas_language')));}
                          if (value.ValidTo !== null && value.ValidTo !== "")
                              {to = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.ValidTo,true,localStorage.getItem('vas_language')));}
                          payment.ValidFrom=from;
                          payment.ValidTo=to;
  
                          let defaultPay='';
                          if (value.IsDefaultPaymentMethod === true){
                              defaultPay=(<Icon
                                Name={"Done"}
                                Size={24}
                                Color={"green"}
                                Align={"left"} />);
                          }
  
                          payment.IsDefaultPaymentMethod=defaultPay;
                          payments.push(payment);
                      }
                  });
              }
              let add = (this.PaymentConfig.Add !== undefined && this.PaymentConfig.Add !== null) ? this.PaymentConfig.Add : true;
              let edit = (this.PaymentConfig.Edit !== undefined && this.PaymentConfig.Edit !== null) ? this.PaymentConfig.Edit : false;

              if(payments.length === 0){
                add = true;
                edit = false;
              }
              if (me.refs.table){
                  me.refs.table.setState({ Data: payments,
                                          Count: payments.length, 
                                          Limit: this.PaymentsModel.Limit, 
                                          Start: this.PaymentsModel.Start, 
                                          End: this.PaymentsModel.Start+payments.length,
                                          Add: add,
                                          Edit:edit 
                                        });
              }
              $("#LoadingIcon").removeClass().addClass('hide');
              
          } else if (observer === "PaymentOption"){
              localStorage.removeItem("PaymentUpdateDate");
              localStorage.setItem("PaymentUpdateDate", this.PaymentOptionsModel.ChangePaymentDate);
          }
      })
    }

    createPayment(field){
      if(field === "Add"){
        Vas.GetView('CreatePayment',{CustomerId:this.CustomerId, NewContract : false , PaymentId : '000000'}, true);
      }else if(field === "Edit"){

        //Abfrage Datum hier und Ergebnis mit übergeben bzw. localstorage

        if(this.refs.table.state.Data.length > 1){
          if(this.state.PaymentId !== "000000"){
            Vas.GetView('CreatePayment',{CustomerId:this.CustomerId, NewContract : false , PaymentId : this.state.PaymentId}, true);
          }else{
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Title={Vas.Resources.Labels["MethodOfPaymentCustomer"]} 
              Message={Vas.Resources.Labels["NoPayments"]} /> 
                      , document.getElementById('messageContainer'));
          }
        }else if(this.refs.table.state.Data.length === 1){
          let paymentId = this.refs.table.state.Data[0].Id;
          Vas.GetView('CreatePayment',{CustomerId:this.CustomerId, NewContract : false , PaymentId : paymentId}, true);

        }
      }
    }

    LoadPaymentDetails(id,Payments)
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('paymentDetails'));
        ReactDOM.render(<CustomerPaymentDetails 
          Id={id} 
          data={Payments} 
          CustomerId={this.CustomerId} 
          reference={this} 
          table={this.refs.table} />
            , document.getElementById('paymentDetails'));
    }

    load(sendData){
      $("#LoadingIcon").removeClass().addClass('loaderSmall');
      this.PaymentsModel.GetPaymentsByCustomerId(this.CustomerId,sendData);
    }

    loadPayment(id){
      let me = this;
      let payments=me.refs.table.state.Data;
      let payment=[];
      for (let i=0;i<payments.length;i++){
          if (payments[i].Id === id){
              payment.push(payments[i]);
          }
      }
      this.setState({PaymentId : id});
      me.LoadPaymentDetails(id,payment);
  }

  LogoClick(){

    var kontrastNumber = localStorage.getItem('Kontrast');

    if(kontrastNumber == "true"){
      $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87;');
      $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
      $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
      $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');

      $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
      $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
      $('.createPaymentForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');
      $('.createPaymentForm #ValidFrom').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
          $('.createPaymentForm #ValidTo').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');

      $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');
    } else {
      $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #3393d3;');
      $('.pagingTable th, .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');
      $('#MenuItem_Bearbeiten').attr('style', 'background-color: #3393d3;');
      $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #3393d3;');

      $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
      $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
      $('.createPaymentForm #Cancel').attr('style', 'background-color: #3393d3; width: 170px; float: right;');
      $('.createPaymentForm #ValidFrom').attr('style', 'background-color: #3393d3; width: 140px; float: left;');
          $('.createPaymentForm #ValidTo').attr('style', 'background-color: #3393d3; width: 140px; float: left;');

      $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #3393d3; border-bottom: 5px solid #3393d3; z-index: 1;');
    }
  }

  FontSizeClick(){
    var schriftgröße = localStorage.getItem('Schriftgröße');

    //Schriftgröße bei Klick in 2er Schritten erhöhen

      if(schriftgröße != null){
            switch(schriftgröße){
              case "0":
                    $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");
  
                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                    $('#tabContent').removeClass("TabContentPaddingLeft80").addClass("TabContentPaddingLeft100");
                    $('#btoChoose').removeClass("btoChooseWidth120_80").addClass("btoChooseWidth140_100");
                    $('.ItemData').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");
                    $('.ItemContracts').attr('style', 'width: 160px;');
                    $('.ItemNewContract').attr('style', 'width: 240px;');
                    $('.customerCardSubTitle').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                    $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                    $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL45").addClass("tableHeaderPaddingL55");
                    $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL10").addClass("tableHeaderPaddingL25");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

              break;
              case "1":

                $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                    $('#tabContent').removeClass("TabContentPaddingLeft100").addClass("TabContentPaddingLeft1");
                    $('#btoChoose').removeClass("btoChooseWidth140_100").addClass("btoChooseWidth100_0");
                    $('.ItemData').removeClass("ItemDataWidth270").addClass("ItemDataWidth190");
                    $('.ItemContracts').attr('style', 'width: 110px;');
                    $('.ItemNewContract').attr('style', 'width: 210px;');
                    $('.customerCardSubTitle').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                    $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                    $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL55").addClass("tableHeaderPaddingL25");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                    $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

              break;
              case "2":
                    $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $('#tabContent').removeClass("TabContentPaddingLeft1").addClass("TabContentPaddingLeft20");
                    $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_20");
                    $('.ItemData').removeClass("ItemDataWidth190").addClass("ItemDataWidth210");
                    $('.customerCardSubTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                    $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                    $('html body div#root.Schriftgröße_17 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft20 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                    $('html body div#root.Schriftgröße_17 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft20 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL25");
                    $('html body div#root.Schriftgröße_17 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft20 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL25");

              break;
              case "3":
                    $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_5").addClass("Schriftgröße_16");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $('#tabContent').removeClass("TabContentPaddingLeft20").addClass("TabContentPaddingLeft40");
                    $('#btoChoose').removeClass("btoChooseWidth100_20").addClass("btoChooseWidth100_40");
                    $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth210");
                    $('.ItemContracts').attr('style', 'width: 140px;');
                    $('.customerCardSubTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                    $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL45");
                    $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL10");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                    $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

              break;
              case "4":
                    $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");
  
                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $('#tabContent').removeClass("TabContentPaddingLeft40").addClass("TabContentPaddingLeft60");
                    $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_60");
                    $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth230");
                    $('.ItemContracts').attr('style', 'width: 140px;');
                    $('.customerCardSubTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                    $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                    $('html body div#root.Schriftgröße_19 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft60 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                    $('html body div#root.Schriftgröße_19 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft60 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL45");
                    $('html body div#root.Schriftgröße_19 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft60 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");

              break;
              case "5":
                $("#root").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                    $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                    $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                    $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                    $('#tabContent').removeClass("TabContentPaddingLeft60").addClass("TabContentPaddingLeft80");
                    $('#btoChoose').removeClass("btoChooseWidth100_60").addClass("btoChooseWidth120_80");
                    $('.ItemData').removeClass("ItemDataWidth230").addClass("ItemDataWidth250");
                    $('.ItemContracts').attr('style', 'width: 160px;');
                    $('.ItemNewContract').attr('style', 'width: 230px;');
                    $('.customerCardSubTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                    $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                    $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                    $('html body div#root.Schriftgröße_20 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft80 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                    $('html body div#root.Schriftgröße_20 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft80 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL45");
                    $('html body div#root.Schriftgröße_20 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft80 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");

              break;
            }
      }
  };

    render()
    {  
      let add = (this.PaymentConfig.Add !== undefined && this.PaymentConfig.Add !== null) ? this.PaymentConfig.Add : true;
      let edit = (this.PaymentConfig.Edit !== undefined && this.PaymentConfig.Edit !== null) ? this.PaymentConfig.Edit : false;

        return (<div id={"customerPayment"}>
          <div id={"customerCardHeadline"} style={{ paddingTop: '10px', paddingLeft: '10px', fontSize: 'calc(15px + 0.2vw)' }}><b>{Vas.Resources.Labels["CustomerPayments"]}</b></div>
          <table style={{ width:'620px',tableLayout:'fixed' }}>
            <tbody>
              <tr>
                <td>
                  <PagingTable  
                    ref="table" 
                    TableReference={this} 
                    DataBaseTable={"B2Zahlweise"} 
                    Selectable={false} 
                    Limit={this.state.Limit} 
                    Start={this.state.Start} 
                    End={this.state.End} 
                    Count={this.state.Count} 
                    Columns={[Vas.Resources.Labels["NameOfBank"],Vas.Resources.Labels["Depositor"],Vas.Resources.Labels["Iban"],
                                    Vas.Resources.Labels["PFrom"],Vas.Resources.Labels["PTo"],Vas.Resources.Labels["Standard"]]}
                    Keys={["BankName","AccountOwner","Iban","ValidFrom","ValidTo","IsDefaultPaymentMethod"]} 
                    Data={this.state.Data}
                    Add={add} 
                    AddClick={()=>{this.createPayment("Add");}} 
                    AddString={Vas.Resources.Labels["Add"]}
                    Edit={edit}
                    EditClick={()=>{this.createPayment("Edit");}} 
                    EditString={Vas.Resources.Labels["Edit"]}
                    Search={false} 
                    AppURL={Vas.ApplicationUrl} 
                    SelectFieldChooseText={Vas.Resources.Labels["PleaseChoose"]} 
                    ApiURL={Vas.ApiUrl} 
                    ApiKey={Vas.ApiKey}
                    TooltipSearchName={Vas.Resources.Tooltips["SearchName"]} 
                    TooltipCsvDownload={Vas.Resources.Tooltips["CsvDownload"]}
                    LabelPage={Vas.Resources.Labels["Page"]} 
                    LabelOf={Vas.Resources.Labels["Of"]} 
                    LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                    CWidth={[120,120,70,90,90,70]}
                    Width={600}
                    UseBurgerMenu={false}
                    RowOnClick={(id)=>{this.loadPayment(id);}}
                    ShowIcons={this.IconConfig.ShowIcons}
                    /> 
                </td>
              </tr>
              <tr>
                <td>
                  <div 
                    className={"paymentDetails"} 
                    id={"paymentDetails"} >{Vas.Resources.Labels["NoPayments"]}</div> 
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        );
    }
}
export default CustomerPaymentData;
